import { render, staticRenderFns } from "./DossierActivityDomainsTable.DynamicView.vue?vue&type=template&id=848c351c&scoped=true"
import script from "./DossierActivityDomainsTable.DynamicView.vue?vue&type=script&lang=ts"
export * from "./DossierActivityDomainsTable.DynamicView.vue?vue&type=script&lang=ts"
import style0 from "./DossierActivityDomainsTable.DynamicView.vue?vue&type=style&index=0&id=848c351c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c351c",
  null
  
)

export default component.exports